import { IRankingsRequest } from "../types/types";
import { callApi } from "./api.service";

export const GetRankings = async (data: IRankingsRequest) => {
  const endpoints = "/api/public/ranking/get-rankings";
  return await callApi(endpoints, "POST", false, undefined, data);
};

export const GetHomeRankings = async () => {
  const endpoints = "/api/public/ranking/home/get-rankings";
  return await callApi(endpoints, "GET", false);
};
